import { render, staticRenderFns } from "./ProcessWorkStatistics.vue?vue&type=template&id=08da33da&scoped=true"
import script from "./ProcessWorkStatistics.vue?vue&type=script&lang=js"
export * from "./ProcessWorkStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProcessWorkStatistics.vue?vue&type=style&index=0&id=08da33da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da33da",
  null
  
)

export default component.exports